"use strict";
UISlider.prototype.createHTML = function () {
    return `
        <div class="ui_slider__amounts">
            <div class="ui_slider__amountMin"></div>
            <div class="ui_slider__amountMax"></div>
        </div>
        <div class="ui_slider__slider">
            <div class="ui_slider__path">
                <div class="ui_slider__progress"></div>
				<div class="ui_slider__slide_path_touch_area" data-uat="ui-slider-slide-path-touch-area"></div>
            </div>
            <div class="bankMyStakeArrow isHidden"></div>
            <div class="bankMyStakeMarker isHidden"></div>
            <div class="ui_slider__btn__wrapper">
                <div class="ui_slider__btn"></div>
            </div>
        </div>
        <button class="bankMyStakeBtn green_btn isHidden" data-uat="bank-my-stake-btn"></button>
        <div class="ui_slider__value"></div>
    `;
};
UISlider.prototype.createNativeHTML = function () {
    return `
        <div class="ui_slider__amounts">
            <div class="ui_slider__amountMin"></div>
            <div class="ui_slider__amountMax"></div>
        </div>
        <div class="ui_slider__slider--native">
            <div class="ui_slider__path">
                <div class="ui_slider__progress"></div>
                <div class="bankMyStakeMarker isHidden"></div>
                <div class="bankMyStakeArrow isHidden"></div>
            </div>
            <input type="range" />
        </div>
        <button class="bankMyStakeBtn green_btn isHidden" data-uat="bank-my-stake-btn"></button>
        <div class="ui_slider__value"></div>
    `;
};
//# sourceMappingURL=TCashoutSlider.js.map